import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClaimItemModule } from '@app/my-zone/shared/claim-item';
import { ClaimsOverviewContentModule } from '@app/my-zone/shared/claims-overview-content';
import { PendingClaimItemModule } from '@app/my-zone/shared/pending-claim-item/pending-claim-item.module';
import { BevestigingsModalModule } from '@app/shared/modals/bevestigingsmodal/bevestigingsmodal.module';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { UiModule } from '@app/shared/ui/ui.module';
import { UxModule } from '@app/shared/ux/ux.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ClaimsOverviewComponent } from './claims-overview.component';
import { ClaimsOverviewContainer } from './claims-overview.container';
import { ClaimsRoutingModule } from './claims-routing.module';
import { ClaimsComponent } from './claims.component';
import { reducers } from './store';
import { AppointmentEffects } from './store/effects/appointments.effects';
import { AppointmentsService } from './store/effects/appointments.service';
import { ClaimsEffects } from './store/effects/claims.effects';
import { ClaimsService } from './store/effects/claims.service';
import { CorrespondencesEffects } from './store/effects/correspondences.effects';
import { CorrespondencesService } from './store/effects/correspondences.service';
import { DocumentsEffects } from './store/effects/documents.effects';
import { DocumentsService } from './store/effects/documents.service';
import { InvolvedPartiesEffects } from './store/effects/involvedParties.effects';
import { InvolvedPartiesService } from './store/effects/involvedParties.service';
import { PhotosEffects } from './store/effects/photos.effects';
import { PhotosService } from './store/effects/photos.service';

@NgModule({
    imports: [
        CommonModule,
        PipesModule,
        LazyLoadImageModule,
        UxModule,
        UiModule,
        ClaimsRoutingModule,
        RouterModule,
        StoreModule.forFeature('myClaims', reducers),
        EffectsModule.forFeature([
            ClaimsEffects,
            CorrespondencesEffects,
            DocumentsEffects,
            AppointmentEffects,
            PhotosEffects,
            InvolvedPartiesEffects,
        ]),
        BevestigingsModalModule,
        ClaimItemModule,
        ClaimsOverviewContentModule,
        PendingClaimItemModule,
    ],
    declarations: [
        ClaimsComponent,
        ClaimsOverviewContainer,
        ClaimsOverviewComponent,
    ],
    providers: [
        ClaimsService,
        CorrespondencesService,
        DocumentsService,
        AppointmentsService,
        PhotosService,
        InvolvedPartiesService,
    ],
})
export class ClaimsModule { }
